import Point from './point';
import assert from 'assert';
const DOM = {};
export default DOM;
DOM.create = function (tagName, className, container) {
    const el = window.document.createElement(tagName);
    if (className !== undefined)
        el.className = className;
    if (container)
        container.appendChild(el);
    return el;
};
DOM.createNS = function (namespaceURI, tagName) {
    const el = window.document.createElementNS(namespaceURI, tagName);
    return el;
};
const docStyle = window.document && window.document.documentElement.style;
function testProp(props) {
    if (!docStyle)
        return props[0];
    for (let i = 0; i < props.length; i++) {
        if (props[i] in docStyle) {
            return props[i];
        }
    }
    return props[0];
}
const selectProp = testProp(['userSelect', 'MozUserSelect', 'WebkitUserSelect', 'msUserSelect']);
let userSelect;
DOM.disableDrag = function () {
    if (docStyle && selectProp) {
        userSelect = docStyle[selectProp];
        docStyle[selectProp] = 'none';
    }
};
DOM.enableDrag = function () {
    if (docStyle && selectProp) {
        docStyle[selectProp] = userSelect;
    }
};
const transformProp = testProp(['transform', 'WebkitTransform']);
DOM.setTransform = function (el, value) {
    // https://github.com/facebook/flow/issues/7754
    // $FlowFixMe
    el.style[transformProp] = value;
};
DOM.addEventListener = function (target, type, callback, options = {}) {
    if ('passive' in options) {
        target.addEventListener(type, callback, options);
    }
    else {
        target.addEventListener(type, callback, options.capture);
    }
};
DOM.removeEventListener = function (target, type, callback, options = {}) {
    if ('passive' in options) {
        target.removeEventListener(type, callback, options);
    }
    else {
        target.removeEventListener(type, callback, options.capture);
    }
};
// Suppress the next click, but only if it's immediate.
const suppressClick = function (e) {
    e.preventDefault();
    e.stopPropagation();
    window.removeEventListener('click', suppressClick, true);
};
DOM.suppressClick = function () {
    window.addEventListener('click', suppressClick, true);
    window.setTimeout(() => {
        window.removeEventListener('click', suppressClick, true);
    }, 0);
};
DOM.mousePos = function (el, e) {
    const rect = el.getBoundingClientRect();
    return new Point(e.clientX - rect.left - el.clientLeft, e.clientY - rect.top - el.clientTop);
};
DOM.touchPos = function (el, touches) {
    const rect = el.getBoundingClientRect(), points = [];
    for (let i = 0; i < touches.length; i++) {
        points.push(new Point(touches[i].clientX - rect.left - el.clientLeft, touches[i].clientY - rect.top - el.clientTop));
    }
    return points;
};
DOM.mouseButton = function (e) {
    assert(e.type === 'mousedown' || e.type === 'mouseup');
    return e.button;
};
DOM.remove = function (node) {
    if (node.parentNode) {
        node.parentNode.removeChild(node);
    }
};
//# sourceMappingURL=dom.js.map